import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
  location: null
};

export default function routerReducer(state = initialState, { type, payload } = {}) {
  if (type === LOCATION_CHANGE) {
    return { ...state, ...payload };
  }

  return state;
}
